import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  label() {
    return faker.lorem.words(3);
  },

  type() {
    return faker.helpers.arrayElement([
      'text',
      'email',
      'textarea',
      'checkbox',
    ]);
  },

  required() {
    return faker.datatype.boolean();
  },

  position() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 4,
      }),
    );
  },
});
